import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { Observable } from "rxjs";

@Directive()
export abstract class BaseSettingsSectionComponent implements OnInit, OnDestroy {
  @Input() loading = false;
  @Input() adminOverride = false;
  @Output() dirtyChange = new EventEmitter<boolean>();

  form: FormGroup;
  isDirty = false;
  isSaving = false;

  protected destroy$ = new Subject<void>();

  abstract buildForm(): FormGroup;
  abstract getSaveObservable(): Observable<any>;
  abstract resetToLastSaved(): void;

  ngOnInit(): void {
    this.form = this.buildForm();
    this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      const dirty = this.form.dirty;
      if (dirty !== this.isDirty) {
        this.isDirty = dirty;
        this.dirtyChange.emit(dirty);
      }
    });
  }

  save(): void {
    if (!this.isDirty || this.isSaving || this.adminOverride) return;
    this.isSaving = true;
    this.getSaveObservable()
      .pipe(finalize(() => (this.isSaving = false)))
      .subscribe(() => {
        this.markPristine();
      });
  }

  discardChanges(): void {
    this.resetToLastSaved();
    this.markPristine();
  }

  protected markPristine(): void {
    this.form.markAsPristine();
    this.isDirty = false;
    this.dirtyChange.emit(false);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
